import { render, staticRenderFns } from "./ChannelsSales.vue?vue&type=template&id=7afc6005"
import script from "./ChannelsSales.vue?vue&type=script&lang=js"
export * from "./ChannelsSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports